
import React from 'react';

import './pattern.scss';

const Pattern = () => {

	return (

		<svg xmlns="http://www.w3.org/2000/svg" width="1336" height="1187" viewBox="0 0 1336 1187">
			<g fill="none" fill-rule="evenodd">
				<g stroke="#FFB81D">
					<g>
						<path d="M710.6 90.308l228.315 131.817L727.066 589.06 1094 800.909l-131.818 228.314-366.934-211.85-211.849 366.935-228.315-131.818 211.849-366.934L0 473.707l131.818-228.315L498.75 457.241l211.85-366.933z" transform="translate(-775 300) translate(776.31 -299)" />
						<path d="M790.6 60.308l228.315 131.817L807.066 559.06 1174 770.909l-131.818 228.314-366.934-211.85-211.849 366.935-228.315-131.818 211.849-366.934L80 443.707l131.818-228.315L578.75 427.241l211.85-366.933z" transform="translate(-775 300) translate(776.31 -299)" />
						<path d="M870.6 30.308l228.315 131.817L887.066 529.06 1254 740.909l-131.818 228.314-366.934-211.85-211.849 366.935L315.084 992.49l211.849-366.934L160 413.707l131.818-228.315L658.75 397.241l211.85-366.933z" transform="translate(-775 300) translate(776.31 -299)" />
						<path d="M950.29 0l228.315 131.818L966.756 498.75l366.934 211.85-131.818 228.314-366.934-211.849L623.09 1094 394.774 962.182l211.85-366.934L239.69 383.399l131.818-228.314L738.44 366.933 950.291 0z" transform="translate(-775 300) translate(776.31 -299)" />
					</g>
				</g>
			</g>
		</svg>
        
	)

}

export default Pattern;
